import * as tslib_1 from "tslib";
export const ParishData = [
    {
        "ID": 10,
        "name": "Aberfoyle Park Parish",
        "first": "100014015",
        "second": "100000009",
        "other": "100013525",
        "active": 1,
        "abn": "11083216579",
        "diocese": 5,
        "chargeFees": 0,
        "code": "aberfoyle",
        "entityType": "0",
        "legalName": null
    },
    {
        "ID": 20,
        "name": "Adelaide Parish",
        "first": "100014017",
        "second": "100000143",
        "other": "100013525",
        "active": 1,
        "abn": "98587321416",
        "diocese": 5,
        "chargeFees": 0,
        "code": "adel",
        "entityType": "0",
        "legalName": null
    },
    {
        "ID": 30,
        "name": "Adelaide Hills Catholic Parish",
        "first": "100014021",
        "second": "100000277",
        "other": "100013525",
        "active": 1,
        "abn": "33748787285",
        "diocese": 5,
        "chargeFees": 0,
        "code": "adelhills",
        "entityType": "0",
        "legalName": null
    },
    {
        "ID": 40,
        "name": "Albert Park Pennington Parish",
        "first": "100014022",
        "second": "100000163",
        "other": "100013525",
        "active": 1,
        "abn": "13 972 542 929",
        "diocese": 5,
        "chargeFees": 0,
        "code": "appp",
        "entityType": "0",
        "legalName": null
    },
    {
        "ID": 50,
        "name": "Blackwood Parish",
        "first": "100014014",
        "second": "100000193",
        "other": "100013525",
        "active": 1,
        "abn": "83417420306",
        "diocese": 5,
        "chargeFees": 0,
        "code": "blackwood",
        "entityType": "0",
        "legalName": null
    },
    {
        "ID": 60,
        "name": "Bordertown Parish",
        "first": "100014016",
        "second": "100000271",
        "other": "100013525",
        "active": 1,
        "abn": "58 540 465 349",
        "diocese": 5,
        "chargeFees": 0,
        "code": "bordertown",
        "entityType": "0",
        "legalName": null
    },
    {
        "ID": 70,
        "name": "Brighton Parish",
        "first": "100014018",
        "second": "100000245",
        "other": "100013525",
        "active": 1,
        "abn": "44 792 429 730",
        "diocese": 5,
        "chargeFees": 0,
        "code": "brighton",
        "entityType": "0",
        "legalName": null
    },
    {
        "ID": 80,
        "name": "Brooklyn Pk Richmond Parish",
        "first": "100027209",
        "second": "100000040",
        "other": "100013525",
        "active": 1,
        "abn": "55781943578",
        "diocese": 5,
        "chargeFees": 0,
        "code": "bprp",
        "entityType": "0",
        "legalName": null
    },
    {
        "ID": 90,
        "name": "Clearview Kilburn Parish",
        "first": "100013965",
        "second": "100000045",
        "other": "100013525",
        "active": 1,
        "abn": "64 543 634 674",
        "diocese": 5,
        "chargeFees": 0,
        "code": "ckp",
        "entityType": "0",
        "legalName": null
    },
    {
        "ID": 100,
        "name": "Croydon Park Parish",
        "first": "100014005",
        "second": "100000089",
        "other": "100013525",
        "active": 1,
        "abn": "63 747 483 784",
        "diocese": 5,
        "chargeFees": 0,
        "code": "croydon",
        "entityType": "0",
        "legalName": null
    },
    {
        "ID": 110,
        "name": "Dernancourt Parish",
        "first": "100000048",
        "second": "100000048",
        "other": "100013525",
        "active": 1,
        "abn": "21465985101",
        "diocese": 5,
        "chargeFees": 0,
        "code": "dernancourt",
        "entityType": "0",
        "legalName": null
    },
    {
        "ID": 120,
        "name": "Edwardstown Parish",
        "first": "100014007",
        "second": "100000090",
        "other": "100013525",
        "active": 1,
        "abn": "35194387314",
        "diocese": 5,
        "chargeFees": 0,
        "code": "edwardstown",
        "entityType": "0",
        "legalName": null
    },
    {
        "ID": 130,
        "name": "Elizabeth Catholic Parish",
        "first": "100013955",
        "second": "100000495",
        "other": "100013525",
        "active": 1,
        "abn": "84 863 303 630",
        "diocese": 5,
        "chargeFees": 0,
        "code": "elizabeth",
        "entityType": "0",
        "legalName": null
    },
    {
        "ID": 140,
        "name": "Emmaus Parish",
        "first": "100013986",
        "second": "100000491",
        "other": "100013525",
        "active": 1,
        "abn": "39 894 756 359",
        "diocese": 5,
        "chargeFees": 0,
        "code": "emmaus",
        "entityType": "0",
        "legalName": null
    },
    {
        "ID": 150,
        "name": "Gawler Parish",
        "first": "100013958",
        "second": "100000314",
        "other": "100013525",
        "active": 1,
        "abn": "46087651520",
        "diocese": 5,
        "chargeFees": 0,
        "code": "gawler",
        "entityType": "0",
        "legalName": null
    },
    {
        "ID": 160,
        "name": "Glenelg Parish",
        "first": "100013962",
        "second": "100000269",
        "other": "100013525",
        "active": 1,
        "abn": "40255655957",
        "diocese": 5,
        "chargeFees": 0,
        "code": "glenelg",
        "entityType": "0",
        "legalName": null
    },
    {
        "ID": 170,
        "name": "Greenacres Walkerville Parish",
        "first": "100013975",
        "second": "100000113",
        "other": "100013525",
        "active": 1,
        "abn": "88 604 579 009",
        "diocese": 5,
        "chargeFees": 0,
        "code": "greenacres",
        "entityType": "0",
        "legalName": null
    },
    {
        "ID": 180,
        "name": "Hallett Cove Parish",
        "first": "100013988",
        "second": "100000992",
        "other": "100013525",
        "active": 1,
        "abn": "53 898 760 139",
        "diocese": 5,
        "chargeFees": 0,
        "code": "hc",
        "entityType": "0",
        "legalName": null
    },
    {
        "ID": 190,
        "name": "Hectorville Parish",
        "first": "100013971",
        "second": "100000075",
        "other": "100013525",
        "active": 1,
        "abn": "64 912 354 887",
        "diocese": 5,
        "chargeFees": 0,
        "code": "hectorville",
        "entityType": "0",
        "legalName": null
    },
    {
        "ID": 200,
        "name": "Henley Beach Parish",
        "first": "100000097",
        "second": "100000097",
        "other": "100013525",
        "active": 1,
        "abn": "57467506005",
        "diocese": 5,
        "chargeFees": 0,
        "code": "henley",
        "entityType": "0",
        "legalName": null
    },
    {
        "ID": 210,
        "name": "Kangaroo Island Parish",
        "first": "100027201",
        "second": "100000067",
        "other": "100013525",
        "active": 1,
        "abn": "81 880 493 436",
        "diocese": 5,
        "chargeFees": 0,
        "code": "ki",
        "entityType": "0",
        "legalName": null
    },
    {
        "ID": 220,
        "name": "Lefevre Catholic Community",
        "first": "100013987",
        "second": "100000038",
        "other": "100013525",
        "active": 1,
        "abn": "30327737311",
        "diocese": 5,
        "chargeFees": 0,
        "code": "lefevre",
        "entityType": "0",
        "legalName": null
    },
    {
        "ID": 230,
        "name": "Lockleys Parish",
        "first": "100013972",
        "second": "100003632",
        "other": "100013525",
        "active": 1,
        "abn": "78960118917",
        "diocese": 5,
        "chargeFees": 0,
        "code": "lockleys",
        "entityType": "0",
        "legalName": null
    },
    {
        "ID": 240,
        "name": "Mater Christi Catholic Church",
        "first": "100000041",
        "second": "100000041",
        "other": "100013525",
        "active": 1,
        "abn": "91190284866",
        "diocese": 5,
        "chargeFees": 0,
        "code": "mc",
        "entityType": "0",
        "legalName": null
    },
    {
        "ID": 250,
        "name": "Millicent Parish",
        "first": "100000970",
        "second": "100000056",
        "other": "100013525",
        "active": 1,
        "abn": "57112768879",
        "diocese": 5,
        "chargeFees": 0,
        "code": "millicent",
        "entityType": "0",
        "legalName": null
    },
    {
        "ID": 260,
        "name": "Morphett Vale Parish",
        "first": "100027204",
        "second": "100000371",
        "other": "100013525",
        "active": 1,
        "abn": "91225447053",
        "diocese": 5,
        "chargeFees": 0,
        "code": "mv",
        "entityType": "0",
        "legalName": null
    },
    {
        "ID": 270,
        "name": "MT Barker Strathalbyn Parish",
        "first": "100013973",
        "second": "100000485",
        "other": "100013525",
        "active": 1,
        "abn": "47624845862",
        "diocese": 5,
        "chargeFees": 0,
        "code": "mbs",
        "entityType": "0",
        "legalName": null
    },
    {
        "ID": 280,
        "name": "MT Gambier Parish",
        "first": "100013999",
        "second": "100000044",
        "other": "100013525",
        "active": 1,
        "abn": "48234827691",
        "diocese": 5,
        "chargeFees": 0,
        "code": "mg",
        "entityType": "0",
        "legalName": null
    },
    {
        "ID": 290,
        "name": "Murray Bridge Parish",
        "first": "100014002",
        "second": "100000200",
        "other": "100013525",
        "active": 1,
        "abn": "58425938661",
        "diocese": 5,
        "chargeFees": 0,
        "code": "mb",
        "entityType": "0",
        "legalName": null
    },
    {
        "ID": 300,
        "name": "Murray Mallee Parish",
        "first": "100029659",
        "second": "100000264",
        "other": "100013525",
        "active": 1,
        "abn": "91439493344",
        "diocese": 5,
        "chargeFees": 0,
        "code": "mm",
        "entityType": "0",
        "legalName": null
    },
    {
        "ID": 310,
        "name": "Naracoorte Parish",
        "first": "100013998",
        "second": "100000115",
        "other": "100013525",
        "active": 1,
        "abn": "70418908309",
        "diocese": 5,
        "chargeFees": 0,
        "code": "naracoorte",
        "entityType": "0",
        "legalName": null
    },
    {
        "ID": 320,
        "name": "Newton Parish",
        "first": "100000278",
        "second": "100000278",
        "other": "100013525",
        "active": 1,
        "abn": "45308861700",
        "diocese": 5,
        "chargeFees": 0,
        "code": "newton",
        "entityType": "0",
        "legalName": null
    },
    {
        "ID": 330,
        "name": "Noarlunga Seaford Parish",
        "first": "100014004",
        "second": "100000203",
        "other": "100013525",
        "active": 1,
        "abn": "43479641367",
        "diocese": 5,
        "chargeFees": 0,
        "code": "ns",
        "entityType": "0",
        "legalName": null
    },
    {
        "ID": 340,
        "name": "North Adelaide Parish",
        "first": "100000098",
        "second": "100000098",
        "other": "100013525",
        "active": 1,
        "abn": "50106994747",
        "diocese": 5,
        "chargeFees": 0,
        "code": "na",
        "entityType": "0",
        "legalName": null
    },
    {
        "ID": 350,
        "name": "Northern Light Catholic Parish",
        "first": "100027955",
        "second": "100027943",
        "other": "100013525",
        "active": 1,
        "abn": "94166091357",
        "diocese": 5,
        "chargeFees": 0,
        "code": "nl",
        "entityType": "0",
        "legalName": null
    },
    {
        "ID": 360,
        "name": "Norwood Parish",
        "first": "100000066",
        "second": "100000066",
        "other": "100013525",
        "active": 1,
        "abn": "46015796089",
        "diocese": 5,
        "chargeFees": 0,
        "code": "norwood",
        "entityType": "0",
        "legalName": null
    },
    {
        "ID": 370,
        "name": "Para Hills Modbury Parish",
        "first": "100013979",
        "second": "100000042",
        "other": "100013525",
        "active": 1,
        "abn": "82540019110",
        "diocese": 5,
        "chargeFees": 0,
        "code": "phm",
        "entityType": "0",
        "legalName": null
    },
    {
        "ID": 380,
        "name": "Payneham Parish",
        "first": "100013974",
        "second": "100000165",
        "other": "100013525",
        "active": 1,
        "abn": "37204139161",
        "diocese": 5,
        "chargeFees": 0,
        "code": "payneham",
        "entityType": "0",
        "legalName": null
    },
    {
        "ID": 390,
        "name": "Penola Parish",
        "first": "100013970",
        "second": "100000021",
        "other": "100013525",
        "active": 1,
        "abn": "61653750133",
        "diocese": 5,
        "chargeFees": 0,
        "code": "penola",
        "entityType": "0",
        "legalName": null
    },
    {
        "ID": 400,
        "name": "Plympton Parish",
        "first": "100013996",
        "second": "100000172",
        "other": "100013525",
        "active": 1,
        "abn": "17963137378",
        "diocese": 5,
        "chargeFees": 0,
        "code": "plympton",
        "entityType": "0",
        "legalName": null
    },
    {
        "ID": 410,
        "name": "Sacred Heart Parish Hindmarsh - Findon",
        "first": "100031471",
        "second": "100000081",
        "other": "100013525",
        "active": 1,
        "abn": "22039371577",
        "diocese": 5,
        "chargeFees": 0,
        "code": "hindmarsh",
        "entityType": "0",
        "legalName": null
    },
    {
        "ID": 420,
        "name": "Salisbury Catholic Parish",
        "first": "100013967",
        "second": "100000101",
        "other": "100013525",
        "active": 1,
        "abn": "56810624414",
        "diocese": 5,
        "chargeFees": 0,
        "code": "salisbury",
        "entityType": "0",
        "legalName": null
    },
    {
        "ID": 430,
        "name": "Sevenhill Parish",
        "first": "100000240",
        "second": "100000240",
        "other": "100013525",
        "active": 1,
        "abn": "76221874518",
        "diocese": 5,
        "chargeFees": 0,
        "code": "sevenhill",
        "entityType": "0",
        "legalName": null
    },
    {
        "ID": 440,
        "name": "St Ann's Catholic Parish",
        "first": "100013961",
        "second": "100000047",
        "other": "100013525",
        "active": 1,
        "abn": "26225156716",
        "diocese": 5,
        "chargeFees": 0,
        "code": "sa",
        "entityType": "0",
        "legalName": null
    },
    {
        "ID": 450,
        "name": "Tranmere Parish",
        "first": "100013964",
        "second": "100000095",
        "other": "100013525",
        "active": 1,
        "abn": "60239874024",
        "diocese": 5,
        "chargeFees": 0,
        "code": "tranmere",
        "entityType": "0",
        "legalName": null
    },
    {
        "ID": 460,
        "name": "Victor Harbor - Goolwa Parish",
        "first": "100013968",
        "second": "100000128",
        "other": "100013525",
        "active": 1,
        "abn": "49422534374",
        "diocese": 5,
        "chargeFees": 0,
        "code": "victor",
        "entityType": "0",
        "legalName": null
    },
    {
        "ID": 470,
        "name": "Virginia Parish",
        "first": "100013957",
        "second": "100000039",
        "other": "100013525",
        "active": 1,
        "abn": "82792443195",
        "diocese": 5,
        "chargeFees": 0,
        "code": "virginia",
        "entityType": "0",
        "legalName": null
    },
    {
        "ID": 480,
        "name": "Willunga Parish",
        "first": "100013994",
        "second": "100000273",
        "other": "100013525",
        "active": 1,
        "abn": "97647909541",
        "diocese": 5,
        "chargeFees": 0,
        "code": "willunga",
        "entityType": "0",
        "legalName": null
    },
    {
        "ID": 490,
        "name": "Yorke Peninsula Cath Parish",
        "first": "100014003",
        "second": "100000061",
        "other": "100013525",
        "active": 1,
        "abn": "76356099203",
        "diocese": 5,
        "chargeFees": 0,
        "code": "yorke",
        "entityType": "0",
        "legalName": null
    },
    {
        "ID": 500,
        "name": "Riverton Manoora Parish",
        "first": "100031586",
        "second": "100000258",
        "other": "100013525",
        "active": 1,
        "abn": "82983886387",
        "diocese": 5,
        "chargeFees": 0,
        "code": "riverton",
        "entityType": "0",
        "legalName": null
    },
    {
        "ID": 510,
        "name": "Ottoway Parish",
        "first": "100000323",
        "second": "100000323",
        "other": "100013525",
        "active": 1,
        "abn": "62578989600",
        "diocese": 5,
        "chargeFees": 0,
        "code": "ottoway",
        "entityType": "0",
        "legalName": null
    },
    {
        "ID": 520,
        "name": "Mallee Border Catholic Parish",
        "first": "100031588",
        "second": "100000188",
        "other": "100013525",
        "active": 1,
        "abn": "93 113 093 187",
        "diocese": 5,
        "chargeFees": 0,
        "code": "mallee",
        "entityType": "0",
        "legalName": null
    },
    {
        "ID": 530,
        "name": "Glen Osmond Parish",
        "first": "100000452",
        "second": "100000452",
        "other": "100013525",
        "active": 1,
        "abn": "85758542301",
        "diocese": 5,
        "chargeFees": 0,
        "code": "glenosmond",
        "entityType": "0",
        "legalName": null
    },
    {
        "ID": 540,
        "name": "Tea Tree Gully",
        "first": "100000226",
        "second": "100000226",
        "other": "100013525",
        "active": 1,
        "abn": "1",
        "diocese": 5,
        "chargeFees": 0,
        "code": "ttg",
        "entityType": "0",
        "legalName": null
    },
    {
        "ID": 15010,
        "name": "St Mary's Cathedral",
        "first": "151001",
        "second": "152001",
        "other": "153001",
        "active": 1,
        "abn": "33209431208",
        "diocese": 15,
        "chargeFees": 0,
        "code": null,
        "entityType": "0",
        "legalName": null
    },
    {
        "ID": 15020,
        "name": "OLSH Alice Springs",
        "first": "151002",
        "second": "152002",
        "other": "153002",
        "active": 1,
        "abn": "58970996442",
        "diocese": 15,
        "chargeFees": 0,
        "code": null,
        "entityType": "0",
        "legalName": null
    },
    {
        "ID": 15030,
        "name": "Holy Spirit Casuarina",
        "first": "151003",
        "second": "152003",
        "other": "153003",
        "active": 1,
        "abn": "28690812636",
        "diocese": 15,
        "chargeFees": 0,
        "code": null,
        "entityType": "0",
        "legalName": null
    },
    {
        "ID": 15040,
        "name": "St Francis of Assisi Humpty Doo",
        "first": "151004",
        "second": "152004",
        "other": "153004",
        "active": 1,
        "abn": "87 206 842 064",
        "diocese": 15,
        "chargeFees": 0,
        "code": null,
        "entityType": "0",
        "legalName": null
    },
    {
        "ID": 15050,
        "name": "St Joseph's Katherine",
        "first": "151005",
        "second": "152005",
        "other": "153005",
        "active": 1,
        "abn": "63858775862",
        "diocese": 15,
        "chargeFees": 0,
        "code": null,
        "entityType": "0",
        "legalName": null
    },
    {
        "ID": 15060,
        "name": "Sacred Heart Nhulunbuy",
        "first": "151006",
        "second": "152006",
        "other": "153006",
        "active": 1,
        "abn": "13894665825",
        "diocese": 15,
        "chargeFees": 0,
        "code": null,
        "entityType": "0",
        "legalName": null
    },
    {
        "ID": 15070,
        "name": "St Pauls Nightcliff",
        "first": "151007",
        "second": "152007",
        "other": "153007",
        "active": 1,
        "abn": "56 688 055 117 ",
        "diocese": 15,
        "chargeFees": 0,
        "code": null,
        "entityType": "0",
        "legalName": null
    },
    {
        "ID": 15080,
        "name": "OLHC Palmerston",
        "first": "151008",
        "second": "152008",
        "other": "153008",
        "active": 1,
        "abn": "44 527 929 160",
        "diocese": 15,
        "chargeFees": 0,
        "code": null,
        "entityType": "0",
        "legalName": null
    },
    {
        "ID": 15090,
        "name": "Holy Family Sanderson",
        "first": "151009",
        "second": "152009",
        "other": "153009",
        "active": 1,
        "abn": "98 860 438 738",
        "diocese": 15,
        "chargeFees": 0,
        "code": null,
        "entityType": "0",
        "legalName": null
    },
    {
        "ID": 15100,
        "name": "Christ the King Tennant Creek",
        "first": "151010",
        "second": "152010",
        "other": "153010",
        "active": 1,
        "abn": "26559855445",
        "diocese": 15,
        "chargeFees": 0,
        "code": null,
        "entityType": "0",
        "legalName": null
    },
    {
        "ID": 15110,
        "name": "St Francis Xavier Daly River",
        "first": "151011",
        "second": "152011",
        "other": "153011",
        "active": 1,
        "abn": "66364590032",
        "diocese": 15,
        "chargeFees": 0,
        "code": null,
        "entityType": "0",
        "legalName": null
    },
    {
        "ID": 15120,
        "name": "St Therese Bathurst Island",
        "first": "151012",
        "second": "152012",
        "other": "153012",
        "active": 1,
        "abn": "62499304813",
        "diocese": 15,
        "chargeFees": 0,
        "code": null,
        "entityType": "0",
        "legalName": null
    },
    {
        "ID": 15130,
        "name": "Our Lady of Victories Melville",
        "first": "151013",
        "second": "152013",
        "other": "153013",
        "active": 1,
        "abn": "45530218640",
        "diocese": 15,
        "chargeFees": 0,
        "code": null,
        "entityType": "0",
        "legalName": null
    },
    {
        "ID": 15140,
        "name": "St Thereses Santa Teresa (Santa Teresa Mission)",
        "first": "151014",
        "second": "152014",
        "other": "153014",
        "active": 1,
        "abn": "78814117751",
        "diocese": 15,
        "chargeFees": 0,
        "code": null,
        "entityType": "0",
        "legalName": null
    },
    {
        "ID": 15150,
        "name": "OLSH Pt Keats",
        "first": "151015",
        "second": "152015",
        "other": "153015",
        "active": 1,
        "abn": "38663415829",
        "diocese": 15,
        "chargeFees": 0,
        "code": null,
        "entityType": "0",
        "legalName": null
    },
    {
        "ID": 15160,
        "name": "St Martin De Porres",
        "first": "151016",
        "second": "152016",
        "other": "153016",
        "active": 1,
        "abn": "64696690941",
        "diocese": 15,
        "chargeFees": 0,
        "code": null,
        "entityType": "0",
        "legalName": null
    },
    {
        "ID": 17000,
        "name": "Pastoral Works Broken Bay",
        "first": "002286",
        "second": "001784",
        "other": "0",
        "active": 1,
        "abn": "87849944998",
        "diocese": 17,
        "chargeFees": 0,
        "code": "pwbb",
        "entityType": "1",
        "legalName": "The Trustee For Roman Catholic Church Diocese Of Broken Bay Charitable Works Fund"
    },
    {
        "ID": 17010,
        "name": "Chatswood",
        "first": "002286",
        "second": "001784",
        "other": "0",
        "active": 1,
        "abn": "34479047154",
        "diocese": 17,
        "chargeFees": 0,
        "code": "chatswood",
        "entityType": "0",
        "legalName": "Catholic Parish Of Our Lady Of Dolours Chatswood"
    },
    {
        "ID": 17020,
        "name": "Arcadia",
        "first": "002286",
        "second": "001784",
        "other": "0",
        "active": 1,
        "abn": "066711",
        "diocese": 17,
        "chargeFees": 0,
        "code": "arcadia",
        "entityType": "0",
        "legalName": "CATHOLIC PARISH OF ST BENEDICT'S ARCADIA"
    },
    {
        "ID": 17030,
        "name": "Epping & Carlingford",
        "first": "62784",
        "second": "8588001",
        "other": "0",
        "active": 1,
        "abn": "29098424805",
        "diocese": 17,
        "chargeFees": 0,
        "code": "ec",
        "entityType": "0",
        "legalName": "Epping & Carlingford Parish Church Account"
    },
    {
        "ID": 17040,
        "name": "Frenchs Forest",
        "first": "62784",
        "second": "1330800",
        "other": "0",
        "active": 0,
        "abn": "31629710181",
        "diocese": 17,
        "chargeFees": 0,
        "code": "ff",
        "entityType": "0",
        "legalName": "Frenchs Forest Catholic Parish Church Account"
    },
    {
        "ID": 17050,
        "name": "Gosford",
        "first": "62784",
        "second": "4238001",
        "other": "0",
        "active": 1,
        "abn": "41262019441",
        "diocese": 17,
        "chargeFees": 0,
        "code": "gosford",
        "entityType": "0",
        "legalName": "CATHOLIC PARISH OF ST PATRICKS GOSFORD"
    },
    {
        "ID": 17060,
        "name": "Hornsby",
        "first": "62784",
        "second": "12268001",
        "other": "0",
        "active": 1,
        "abn": "36225583480",
        "diocese": 17,
        "chargeFees": 0,
        "code": "hornsby",
        "entityType": "0",
        "legalName": "HORNSBY CATHEDRAL PARISH"
    },
    {
        "ID": 17070,
        "name": "Kincumber",
        "first": "62784",
        "second": "11948001",
        "other": "0",
        "active": 0,
        "abn": "61552116301",
        "diocese": 17,
        "chargeFees": 0,
        "code": "kincumber",
        "entityType": "0",
        "legalName": "CATHOLIC PARISH OF HOLY CROSS KINCUMBER"
    },
    {
        "ID": 17080,
        "name": "Korean",
        "first": "62784",
        "second": "15188200",
        "other": "0",
        "active": 0,
        "abn": "71211976689",
        "diocese": 17,
        "chargeFees": 0,
        "code": "korean",
        "entityType": "0",
        "legalName": "Korean Catholic Chaplaincy Church Acc"
    },
    {
        "ID": 17090,
        "name": "Ku-ring-gai Chase",
        "first": "62784",
        "second": "12388801",
        "other": "0",
        "active": 1,
        "abn": "77021529754",
        "diocese": 17,
        "chargeFees": 0,
        "code": "kc",
        "entityType": "0",
        "legalName": "KU-RING-GAI CHASE CATHOLIC PARISH"
    },
    {
        "ID": 17100,
        "name": "Lindfield Killara",
        "first": "62784",
        "second": "11168801",
        "other": "0",
        "active": 1,
        "abn": "31709356168",
        "diocese": 17,
        "chargeFees": 0,
        "code": "lk",
        "entityType": "0",
        "legalName": "LINDFIELD KILLARA CATHOLIC PARISH"
    },
    {
        "ID": 17110,
        "name": "Lower North Shore",
        "first": "62784",
        "second": "13928801",
        "other": "0",
        "active": 1,
        "abn": "48802300677",
        "diocese": 17,
        "chargeFees": 0,
        "code": "lns",
        "entityType": "0",
        "legalName": "CATHOLIC PARISH OF LOWER NORTH SHORE"
    },
    {
        "ID": 17120,
        "name": "Manly Freshwater",
        "first": "62784",
        "second": "13958801",
        "other": "0",
        "active": 1,
        "abn": "85035988193",
        "diocese": 17,
        "chargeFees": 0,
        "code": "manly",
        "entityType": "0",
        "legalName": "Manly Freshwater Parish Church Account"
    },
    {
        "ID": 17130,
        "name": "North Harbour",
        "first": "62784",
        "second": "28478001",
        "other": "0",
        "active": 0,
        "abn": "89826181217",
        "diocese": 17,
        "chargeFees": 0,
        "code": "nh",
        "entityType": "0",
        "legalName": "Catholic Community-Nth Harbour Church Account"
    },
    {
        "ID": 17140,
        "name": "Pennant Hills",
        "first": "62784",
        "second": "323880",
        "other": "0",
        "active": 1,
        "abn": "35776316273",
        "diocese": 17,
        "chargeFees": 0,
        "code": "ph",
        "entityType": "0",
        "legalName": "Pennant Hills Parish Church Account"
    },
    {
        "ID": 17150,
        "name": "Pittwater",
        "first": "62784",
        "second": "4558801",
        "other": "0",
        "active": 1,
        "abn": "41140719462",
        "diocese": 17,
        "chargeFees": 0,
        "code": "pittwater",
        "entityType": "0",
        "legalName": "Pittwater Parish Church Account"
    },
    {
        "ID": 17160,
        "name": "Pymble",
        "first": "62784",
        "second": "12228801",
        "other": "0",
        "active": 0,
        "abn": "73650652282",
        "diocese": 17,
        "chargeFees": 0,
        "code": "pymble",
        "entityType": "0",
        "legalName": "Pymble Catholic Parish Church Building Fund Account"
    },
    {
        "ID": 17170,
        "name": "St Ives",
        "first": "62784",
        "second": "12678801",
        "other": "0",
        "active": 0,
        "abn": "36382418850",
        "diocese": 17,
        "chargeFees": 0,
        "code": "si",
        "entityType": "0",
        "legalName": "St Ives Parish Church Account"
    },
    {
        "ID": 17180,
        "name": "Warnervale",
        "first": "62784",
        "second": "21388801",
        "other": "0",
        "active": 0,
        "abn": "88268240490",
        "diocese": 17,
        "chargeFees": 0,
        "code": "warnervale",
        "entityType": "0",
        "legalName": "St Mary MacKillop Parish Church Account"
    },
    {
        "ID": 17190,
        "name": "Terrigal",
        "first": "62784",
        "second": "11548801",
        "other": "0",
        "active": 0,
        "abn": "30457759100",
        "diocese": 17,
        "chargeFees": 0,
        "code": "terrigal",
        "entityType": "0",
        "legalName": "Terrigal Parish Working Account"
    },
    {
        "ID": 17200,
        "name": "The Entrance",
        "first": "62784",
        "second": "13388801",
        "other": "0",
        "active": 0,
        "abn": "41194711622",
        "diocese": 17,
        "chargeFees": 0,
        "code": "entrance",
        "entityType": "0",
        "legalName": "The Entrance Parish Church Account"
    },
    {
        "ID": 17210,
        "name": "The Lakes",
        "first": "62784",
        "second": "1294861",
        "other": "0",
        "active": 1,
        "abn": "57360206519",
        "diocese": 17,
        "chargeFees": 0,
        "code": "lakes",
        "entityType": "0",
        "legalName": "The Lakes Catholic Parish EFT Receipts"
    },
    {
        "ID": 17220,
        "name": "Toukley",
        "first": "62784",
        "second": "6238801",
        "other": "0",
        "active": 0,
        "abn": "97915180732",
        "diocese": 17,
        "chargeFees": 0,
        "code": "toukley",
        "entityType": "0",
        "legalName": "Toukley Parish Church Account"
    },
    {
        "ID": 17230,
        "name": "Wahroonga",
        "first": "62784",
        "second": "13898801",
        "other": "0",
        "active": 1,
        "abn": "18725911948",
        "diocese": 17,
        "chargeFees": 0,
        "code": "wahroonga",
        "entityType": "0",
        "legalName": "Wahroonga Parish Church Account"
    },
    {
        "ID": 17240,
        "name": "Warringah",
        "first": "62784",
        "second": "12178801",
        "other": "0",
        "active": 1,
        "abn": "25203447491",
        "diocese": 17,
        "chargeFees": 0,
        "code": "warringah",
        "entityType": "0",
        "legalName": "Warringah Parish Church Account"
    },
    {
        "ID": 17250,
        "name": "Woy Woy",
        "first": "62784",
        "second": "12008801",
        "other": "0",
        "active": 1,
        "abn": "51683134215",
        "diocese": 17,
        "chargeFees": 0,
        "code": "woywoy",
        "entityType": "0",
        "legalName": "Woy Woy Peninsula Parish Church Account"
    },
    {
        "ID": 17260,
        "name": "Wyoming",
        "first": "62784",
        "second": "4448801",
        "other": "0",
        "active": 0,
        "abn": "92156784632",
        "diocese": 17,
        "chargeFees": 0,
        "code": "wyoming",
        "entityType": "0",
        "legalName": "Wyoming Parish Church Account"
    },
    {
        "ID": 17270,
        "name": "Wyong",
        "first": "62784",
        "second": "13528801",
        "other": "0",
        "active": 1,
        "abn": "98810918260",
        "diocese": 17,
        "chargeFees": 0,
        "code": "wyong",
        "entityType": "0",
        "legalName": "Wyong Parish No 1 Account"
    },
    {
        "ID": 25010,
        "name": "Albion Park",
        "first": "001908",
        "second": "001754",
        "other": "0",
        "active": 1,
        "abn": "066711",
        "diocese": 25,
        "chargeFees": 0,
        "code": null,
        "entityType": "0",
        "legalName": null
    },
    {
        "ID": 25020,
        "name": "Berkeley",
        "first": "002046",
        "second": "004097",
        "other": "0",
        "active": 1,
        "abn": "066711",
        "diocese": 25,
        "chargeFees": 0,
        "code": null,
        "entityType": "0",
        "legalName": null
    },
    {
        "ID": 25030,
        "name": "Bowral",
        "first": "001718",
        "second": "001758",
        "other": "0",
        "active": 1,
        "abn": "066711",
        "diocese": 25,
        "chargeFees": 0,
        "code": null,
        "entityType": "0",
        "legalName": null
    },
    {
        "ID": 25040,
        "name": "Bulli",
        "first": "002056",
        "second": "001760",
        "other": "0",
        "active": 1,
        "abn": "066711",
        "diocese": 25,
        "chargeFees": 0,
        "code": null,
        "entityType": "0",
        "legalName": null
    },
    {
        "ID": 25050,
        "name": "Camden",
        "first": "002066",
        "second": "001761",
        "other": "0",
        "active": 1,
        "abn": "066711",
        "diocese": 25,
        "chargeFees": 0,
        "code": null,
        "entityType": "0",
        "legalName": null
    },
    {
        "ID": 25060,
        "name": "Campbelltown",
        "first": "002036",
        "second": "001875",
        "other": "0",
        "active": 1,
        "abn": "066711",
        "diocese": 25,
        "chargeFees": 0,
        "code": null,
        "entityType": "0",
        "legalName": null
    },
    {
        "ID": 25070,
        "name": "Corrimal",
        "first": "002086",
        "second": "003669",
        "other": "0",
        "active": 1,
        "abn": "066711",
        "diocese": 25,
        "chargeFees": 0,
        "code": null,
        "entityType": "0",
        "legalName": null
    },
    {
        "ID": 25080,
        "name": "Dapto",
        "first": "002096",
        "second": "001768",
        "other": "0",
        "active": 1,
        "abn": "066711",
        "diocese": 25,
        "chargeFees": 0,
        "code": null,
        "entityType": "0",
        "legalName": null
    },
    {
        "ID": 25090,
        "name": "Eagle Vale",
        "first": "002106",
        "second": "002359",
        "other": "0",
        "active": 1,
        "abn": "066711",
        "diocese": 25,
        "chargeFees": 0,
        "code": null,
        "entityType": "0",
        "legalName": null
    },
    {
        "ID": 25100,
        "name": "Fairy Meadow",
        "first": "001728",
        "second": "001733",
        "other": "0",
        "active": 1,
        "abn": "066711",
        "diocese": 25,
        "chargeFees": 0,
        "code": null,
        "entityType": "0",
        "legalName": null
    },
    {
        "ID": 25110,
        "name": "Gwynneville",
        "first": "002116",
        "second": "001770",
        "other": "0",
        "active": 1,
        "abn": "066711",
        "diocese": 25,
        "chargeFees": 0,
        "code": null,
        "entityType": "0",
        "legalName": null
    },
    {
        "ID": 25120,
        "name": "Helensburgh",
        "first": "001968",
        "second": "001675",
        "other": "0",
        "active": 1,
        "abn": "066711",
        "diocese": 25,
        "chargeFees": 0,
        "code": null,
        "entityType": "0",
        "legalName": null
    },
    {
        "ID": 25130,
        "name": "Ingleburn",
        "first": "001978",
        "second": "001773",
        "other": "0",
        "active": 1,
        "abn": "066711",
        "diocese": 25,
        "chargeFees": 0,
        "code": null,
        "entityType": "0",
        "legalName": null
    },
    {
        "ID": 25140,
        "name": "Kiama",
        "first": "002126",
        "second": "001774",
        "other": "0",
        "active": 1,
        "abn": "066711",
        "diocese": 25,
        "chargeFees": 0,
        "code": null,
        "entityType": "0",
        "legalName": null
    },
    {
        "ID": 25150,
        "name": "Macquarie Fields",
        "first": "002136",
        "second": "001737",
        "other": "0",
        "active": 1,
        "abn": "066711",
        "diocese": 25,
        "chargeFees": 0,
        "code": null,
        "entityType": "0",
        "legalName": null
    },
    {
        "ID": 25160,
        "name": "Milton",
        "first": "002146",
        "second": "001776",
        "other": "0",
        "active": 1,
        "abn": "066711",
        "diocese": 25,
        "chargeFees": 0,
        "code": null,
        "entityType": "0",
        "legalName": null
    },
    {
        "ID": 25170,
        "name": "Mittagong",
        "first": "002156",
        "second": "001778",
        "other": "0",
        "active": 1,
        "abn": "066711",
        "diocese": 25,
        "chargeFees": 0,
        "code": null,
        "entityType": "0",
        "legalName": null
    },
    {
        "ID": 25180,
        "name": "Moss Vale",
        "first": "002166",
        "second": "001780",
        "other": "0",
        "active": 1,
        "abn": "066711",
        "diocese": 25,
        "chargeFees": 0,
        "code": null,
        "entityType": "0",
        "legalName": null
    },
    {
        "ID": 25190,
        "name": "Nowra",
        "first": "002176",
        "second": "001782",
        "other": "0",
        "active": 1,
        "abn": "066711",
        "diocese": 25,
        "chargeFees": 0,
        "code": null,
        "entityType": "0",
        "legalName": null
    },
    {
        "ID": 25200,
        "name": "Picton",
        "first": "002196",
        "second": "001783",
        "other": "0",
        "active": 1,
        "abn": "066711",
        "diocese": 25,
        "chargeFees": 0,
        "code": null,
        "entityType": "0",
        "legalName": null
    },
    {
        "ID": 25210,
        "name": "Port Kembla",
        "first": "002206",
        "second": "001784",
        "other": "0",
        "active": 1,
        "abn": "066711",
        "diocese": 25,
        "chargeFees": 0,
        "code": null,
        "entityType": "0",
        "legalName": null
    },
    {
        "ID": 25220,
        "name": "Oran Park",
        "first": "002186",
        "second": "007410",
        "other": "0",
        "active": 1,
        "abn": "066711",
        "diocese": 25,
        "chargeFees": 0,
        "code": null,
        "entityType": "0",
        "legalName": null
    },
    {
        "ID": 25230,
        "name": "Rosemeadow",
        "first": "002026",
        "second": "002395",
        "other": "0",
        "active": 1,
        "abn": "066711",
        "diocese": 25,
        "chargeFees": 0,
        "code": null,
        "entityType": "0",
        "legalName": null
    },
    {
        "ID": 25240,
        "name": "Ruse",
        "first": "002216",
        "second": "001785",
        "other": "0",
        "active": 1,
        "abn": "066711",
        "diocese": 25,
        "chargeFees": 0,
        "code": null,
        "entityType": "0",
        "legalName": null
    },
    {
        "ID": 25250,
        "name": "Shellharbour City",
        "first": "002226",
        "second": "004266",
        "other": "0",
        "active": 1,
        "abn": "066711",
        "diocese": 25,
        "chargeFees": 0,
        "code": null,
        "entityType": "0",
        "legalName": null
    },
    {
        "ID": 25260,
        "name": "The Oaks",
        "first": "001218",
        "second": "001681",
        "other": "0",
        "active": 1,
        "abn": "066711",
        "diocese": 25,
        "chargeFees": 0,
        "code": null,
        "entityType": "0",
        "legalName": null
    },
    {
        "ID": 25270,
        "name": "Thirroul",
        "first": "002246",
        "second": "001788",
        "other": "0",
        "active": 1,
        "abn": "066711",
        "diocese": 25,
        "chargeFees": 0,
        "code": null,
        "entityType": "0",
        "legalName": null
    },
    {
        "ID": 25280,
        "name": "Unanderra",
        "first": "002256",
        "second": "001789",
        "other": "0",
        "active": 1,
        "abn": "066711",
        "diocese": 25,
        "chargeFees": 0,
        "code": null,
        "entityType": "0",
        "legalName": null
    },
    {
        "ID": 25290,
        "name": "Varroville",
        "first": "002376",
        "second": "002237",
        "other": "0",
        "active": 1,
        "abn": "066711",
        "diocese": 25,
        "chargeFees": 0,
        "code": null,
        "entityType": "0",
        "legalName": null
    },
    {
        "ID": 25300,
        "name": "Warrawong",
        "first": "002266",
        "second": "001792",
        "other": "0",
        "active": 1,
        "abn": "066711",
        "diocese": 25,
        "chargeFees": 0,
        "code": null,
        "entityType": "0",
        "legalName": null
    },
    {
        "ID": 25310,
        "name": "West Wollongong",
        "first": "002276",
        "second": "001793",
        "other": "0",
        "active": 1,
        "abn": "066711",
        "diocese": 25,
        "chargeFees": 0,
        "code": null,
        "entityType": "0",
        "legalName": null
    },
    {
        "ID": 25320,
        "name": "Wollongong (Cathedral)",
        "first": "002286",
        "second": "001784",
        "other": "0",
        "active": 1,
        "abn": "066711",
        "diocese": 25,
        "chargeFees": 0,
        "code": null,
        "entityType": "0",
        "legalName": null
    },
    {
        "ID": 50050,
        "name": "Priest Retirement Fund",
        "first": "100031434",
        "second": "100031434",
        "other": "100031434",
        "active": 1,
        "abn": "1",
        "diocese": 5,
        "chargeFees": 0,
        "code": "prf",
        "entityType": "1",
        "legalName": null
    },
    {
        "ID": 50060,
        "name": "Catholic Charities",
        "first": "100001126",
        "second": "100001126",
        "other": "100001126",
        "active": 1,
        "abn": "1",
        "diocese": 5,
        "chargeFees": 0,
        "code": "cc",
        "entityType": "1",
        "legalName": null
    },
    {
        "ID": 50070,
        "name": "Catholic Charities - Schools",
        "first": "100001126",
        "second": "100001126",
        "other": "100001126",
        "active": 1,
        "abn": "1",
        "diocese": 5,
        "chargeFees": 0,
        "code": "me4u",
        "entityType": "1",
        "legalName": null
    },
    {
        "ID": 50080,
        "name": "Me4U-All Saints Catholic Primary School",
        "first": "100001126",
        "second": "100001126",
        "other": "100001126",
        "active": 1,
        "abn": "1",
        "diocese": 5,
        "chargeFees": 0,
        "code": "m4u-ascps",
        "entityType": "1",
        "legalName": null
    },
    {
        "ID": 50090,
        "name": "Me4U-Antonio Catholic School",
        "first": "100001126",
        "second": "100001126",
        "other": "100001126",
        "active": 1,
        "abn": "1",
        "diocese": 5,
        "chargeFees": 0,
        "code": "m4u-acs",
        "entityType": "1",
        "legalName": null
    },
    {
        "ID": 50100,
        "name": "Me4U-Blackfriars Priory School",
        "first": "100001126",
        "second": "100001126",
        "other": "100001126",
        "active": 1,
        "abn": "1",
        "diocese": 5,
        "chargeFees": 0,
        "code": "m4u-bps",
        "entityType": "1",
        "legalName": null
    },
    {
        "ID": 50110,
        "name": "Me4U-Cabra Dominican College",
        "first": "100001126",
        "second": "100001126",
        "other": "100001126",
        "active": 1,
        "abn": "1",
        "diocese": 5,
        "chargeFees": 0,
        "code": "m4u-cdc",
        "entityType": "1",
        "legalName": null
    },
    {
        "ID": 50120,
        "name": "Me4U-Cardijn College",
        "first": "100001126",
        "second": "100001126",
        "other": "100001126",
        "active": 1,
        "abn": "1",
        "diocese": 5,
        "chargeFees": 0,
        "code": "m4u-cc",
        "entityType": "1",
        "legalName": null
    },
    {
        "ID": 50130,
        "name": "Me4U-Caritas College",
        "first": "100001126",
        "second": "100001126",
        "other": "100001126",
        "active": 1,
        "abn": "1",
        "diocese": 5,
        "chargeFees": 0,
        "code": "m4u-cac",
        "entityType": "1",
        "legalName": null
    },
    {
        "ID": 50140,
        "name": "Me4U-Catherine Mcauley School",
        "first": "100001126",
        "second": "100001126",
        "other": "100001126",
        "active": 1,
        "abn": "1",
        "diocese": 5,
        "chargeFees": 0,
        "code": "m4u-cms",
        "entityType": "1",
        "legalName": null
    },
    {
        "ID": 50150,
        "name": "Me4U-Christ the King School",
        "first": "100001126",
        "second": "100001126",
        "other": "100001126",
        "active": 1,
        "abn": "1",
        "diocese": 5,
        "chargeFees": 0,
        "code": "m4u-ctks",
        "entityType": "1",
        "legalName": null
    },
    {
        "ID": 50160,
        "name": "Me4U-Christian Brothers College",
        "first": "100001126",
        "second": "100001126",
        "other": "100001126",
        "active": 1,
        "abn": "1",
        "diocese": 5,
        "chargeFees": 0,
        "code": "m4u-cbc",
        "entityType": "1",
        "legalName": null
    },
    {
        "ID": 50170,
        "name": "Me4U-Dominican School",
        "first": "100001126",
        "second": "100001126",
        "other": "100001126",
        "active": 1,
        "abn": "1",
        "diocese": 5,
        "chargeFees": 0,
        "code": "m4u-ds",
        "entityType": "1",
        "legalName": null
    },
    {
        "ID": 50180,
        "name": "Me4U-Emmaus Catholic School",
        "first": "100001126",
        "second": "100001126",
        "other": "100001126",
        "active": 1,
        "abn": "1",
        "diocese": 5,
        "chargeFees": 0,
        "code": "m4u-ecs",
        "entityType": "1",
        "legalName": null
    },
    {
        "ID": 50190,
        "name": "Me4U-Galilee Catholic School",
        "first": "100001126",
        "second": "100001126",
        "other": "100001126",
        "active": 1,
        "abn": "1",
        "diocese": 5,
        "chargeFees": 0,
        "code": "m4u-gcs",
        "entityType": "1",
        "legalName": null
    },
    {
        "ID": 50200,
        "name": "Me4U-Gleeson College",
        "first": "100001126",
        "second": "100001126",
        "other": "100001126",
        "active": 1,
        "abn": "1",
        "diocese": 5,
        "chargeFees": 0,
        "code": "m4u-gc",
        "entityType": "1",
        "legalName": null
    },
    {
        "ID": 50210,
        "name": "Me4U-Holy Family Catholic School",
        "first": "100001126",
        "second": "100001126",
        "other": "100001126",
        "active": 1,
        "abn": "1",
        "diocese": 5,
        "chargeFees": 0,
        "code": "m4u-hfcs",
        "entityType": "1",
        "legalName": null
    },
    {
        "ID": 50220,
        "name": "Me4U-Immaculate Heart of Mary",
        "first": "100001126",
        "second": "100001126",
        "other": "100001126",
        "active": 1,
        "abn": "1",
        "diocese": 5,
        "chargeFees": 0,
        "code": "m4u-ihom",
        "entityType": "1",
        "legalName": null
    },
    {
        "ID": 50230,
        "name": "Me4U-Kildare College",
        "first": "100001126",
        "second": "100001126",
        "other": "100001126",
        "active": 1,
        "abn": "1",
        "diocese": 5,
        "chargeFees": 0,
        "code": "m4u-kc",
        "entityType": "1",
        "legalName": null
    },
    {
        "ID": 50240,
        "name": "Me4U-Loreto College",
        "first": "100001126",
        "second": "100001126",
        "other": "100001126",
        "active": 1,
        "abn": "1",
        "diocese": 5,
        "chargeFees": 0,
        "code": "m4u-lc",
        "entityType": "1",
        "legalName": null
    },
    {
        "ID": 50250,
        "name": "Me4U-Mary MacKillop College",
        "first": "100001126",
        "second": "100001126",
        "other": "100001126",
        "active": 1,
        "abn": "1",
        "diocese": 5,
        "chargeFees": 0,
        "code": "m4u-mmc",
        "entityType": "1",
        "legalName": null
    },
    {
        "ID": 50260,
        "name": "Me4U-Mary Mackillop Memorial School",
        "first": "100001126",
        "second": "100001126",
        "other": "100001126",
        "active": 1,
        "abn": "1",
        "diocese": 5,
        "chargeFees": 0,
        "code": "m4u-mmms",
        "entityType": "1",
        "legalName": null
    },
    {
        "ID": 50270,
        "name": "Me4U-McAuley Community School",
        "first": "100001126",
        "second": "100001126",
        "other": "100001126",
        "active": 1,
        "abn": "1",
        "diocese": 5,
        "chargeFees": 0,
        "code": "m4u-mcs",
        "entityType": "1",
        "legalName": null
    },
    {
        "ID": 50280,
        "name": "Me4U-Mercedes College",
        "first": "100001126",
        "second": "100001126",
        "other": "100001126",
        "active": 1,
        "abn": "1",
        "diocese": 5,
        "chargeFees": 0,
        "code": "m4u-mc",
        "entityType": "1",
        "legalName": null
    },
    {
        "ID": 50290,
        "name": "Me4U-Mount Carmel College",
        "first": "100001126",
        "second": "100001126",
        "other": "100001126",
        "active": 1,
        "abn": "1",
        "diocese": 5,
        "chargeFees": 0,
        "code": "m4u-mcc",
        "entityType": "1",
        "legalName": null
    },
    {
        "ID": 50300,
        "name": "Me4U-Nazareth Catholic College",
        "first": "100001126",
        "second": "100001126",
        "other": "100001126",
        "active": 1,
        "abn": "1",
        "diocese": 5,
        "chargeFees": 0,
        "code": "m4u-ncc",
        "entityType": "1",
        "legalName": null
    },
    {
        "ID": 50310,
        "name": "Me4U-Our Lady of Grace School",
        "first": "100001126",
        "second": "100001126",
        "other": "100001126",
        "active": 1,
        "abn": "1",
        "diocese": 5,
        "chargeFees": 0,
        "code": "m4u-ologs",
        "entityType": "1",
        "legalName": null
    },
    {
        "ID": 50320,
        "name": "Me4U-Our Lady of Hope",
        "first": "100001126",
        "second": "100001126",
        "other": "100001126",
        "active": 1,
        "abn": "1",
        "diocese": 5,
        "chargeFees": 0,
        "code": "m4u-oloh",
        "entityType": "1",
        "legalName": null
    },
    {
        "ID": 50330,
        "name": "Me4U-Our Lady of La Vang",
        "first": "100001126",
        "second": "100001126",
        "other": "100001126",
        "active": 1,
        "abn": "1",
        "diocese": 5,
        "chargeFees": 0,
        "code": "m4u-ololv",
        "entityType": "1",
        "legalName": null
    },
    {
        "ID": 50340,
        "name": "Me4U-Our Lady of Mount Carmel Parish School",
        "first": "100001126",
        "second": "100001126",
        "other": "100001126",
        "active": 1,
        "abn": "1",
        "diocese": 5,
        "chargeFees": 0,
        "code": "m4u-olomcps",
        "entityType": "1",
        "legalName": null
    },
    {
        "ID": 50350,
        "name": "Me4U-Our Lady of the River School",
        "first": "100001126",
        "second": "100001126",
        "other": "100001126",
        "active": 1,
        "abn": "1",
        "diocese": 5,
        "chargeFees": 0,
        "code": "m4u-olotrs",
        "entityType": "1",
        "legalName": null
    },
    {
        "ID": 50360,
        "name": "Me4U-Our Lady of the Sacred Heart College",
        "first": "100001126",
        "second": "100001126",
        "other": "100001126",
        "active": 1,
        "abn": "1",
        "diocese": 5,
        "chargeFees": 0,
        "code": "m4u-olotshc",
        "entityType": "1",
        "legalName": null
    },
    {
        "ID": 50370,
        "name": "Me4U-Our Lady of the Visitation",
        "first": "100001126",
        "second": "100001126",
        "other": "100001126",
        "active": 1,
        "abn": "1",
        "diocese": 5,
        "chargeFees": 0,
        "code": "m4u-olotv",
        "entityType": "1",
        "legalName": null
    },
    {
        "ID": 50380,
        "name": "Me4U-Our Lady Queen of Peace",
        "first": "100001126",
        "second": "100001126",
        "other": "100001126",
        "active": 1,
        "abn": "1",
        "diocese": 5,
        "chargeFees": 0,
        "code": "m4u-olqop",
        "entityType": "1",
        "legalName": null
    },
    {
        "ID": 50390,
        "name": "Me4U-Rosary School",
        "first": "100001126",
        "second": "100001126",
        "other": "100001126",
        "active": 1,
        "abn": "1",
        "diocese": 5,
        "chargeFees": 0,
        "code": "m4u-rs",
        "entityType": "1",
        "legalName": null
    },
    {
        "ID": 50400,
        "name": "Me4U-Rostrevor College",
        "first": "100001126",
        "second": "100001126",
        "other": "100001126",
        "active": 1,
        "abn": "1",
        "diocese": 5,
        "chargeFees": 0,
        "code": "m4u-rc",
        "entityType": "1",
        "legalName": null
    },
    {
        "ID": 50410,
        "name": "Me4U-Sacred Heart Middle School",
        "first": "100001126",
        "second": "100001126",
        "other": "100001126",
        "active": 1,
        "abn": "1",
        "diocese": 5,
        "chargeFees": 0,
        "code": "m4u-shms",
        "entityType": "1",
        "legalName": null
    },
    {
        "ID": 50420,
        "name": "Me4U-Saint David's Parish School",
        "first": "100001126",
        "second": "100001126",
        "other": "100001126",
        "active": 1,
        "abn": "1",
        "diocese": 5,
        "chargeFees": 0,
        "code": "m4u-sdps",
        "entityType": "1",
        "legalName": null
    },
    {
        "ID": 50430,
        "name": "Me4U-Samaritan College",
        "first": "100001126",
        "second": "100001126",
        "other": "100001126",
        "active": 1,
        "abn": "1",
        "diocese": 5,
        "chargeFees": 0,
        "code": "m4u-sc",
        "entityType": "1",
        "legalName": null
    },
    {
        "ID": 50440,
        "name": "Me4U-School of the Nativity",
        "first": "100001126",
        "second": "100001126",
        "other": "100001126",
        "active": 1,
        "abn": "1",
        "diocese": 5,
        "chargeFees": 0,
        "code": "m4u-sotn",
        "entityType": "1",
        "legalName": null
    },
    {
        "ID": 50450,
        "name": "Me4U-St Albert's Catholic School",
        "first": "100001126",
        "second": "100001126",
        "other": "100001126",
        "active": 1,
        "abn": "1",
        "diocese": 5,
        "chargeFees": 0,
        "code": "m4u-sacs",
        "entityType": "1",
        "legalName": null
    },
    {
        "ID": 50460,
        "name": "Me4U-St Aloysius",
        "first": "100001126",
        "second": "100001126",
        "other": "100001126",
        "active": 1,
        "abn": "1",
        "diocese": 5,
        "chargeFees": 0,
        "code": "m4u-sa",
        "entityType": "1",
        "legalName": null
    },
    {
        "ID": 50470,
        "name": "Me4U-St Anthony's Catholic Primary School",
        "first": "100001126",
        "second": "100001126",
        "other": "100001126",
        "active": 1,
        "abn": "1",
        "diocese": 5,
        "chargeFees": 0,
        "code": "m4u-sacps",
        "entityType": "1",
        "legalName": null
    },
    {
        "ID": 50480,
        "name": "Me4U-St Anthony's School",
        "first": "100001126",
        "second": "100001126",
        "other": "100001126",
        "active": 1,
        "abn": "1",
        "diocese": 5,
        "chargeFees": 0,
        "code": "m4u-sas",
        "entityType": "1",
        "legalName": null
    },
    {
        "ID": 50490,
        "name": "Me4U-St Augustine's Parish School",
        "first": "100001126",
        "second": "100001126",
        "other": "100001126",
        "active": 1,
        "abn": "1",
        "diocese": 5,
        "chargeFees": 0,
        "code": "m4u-saps",
        "entityType": "1",
        "legalName": null
    },
    {
        "ID": 50500,
        "name": "Me4U-St Barbara's Parish School",
        "first": "100001126",
        "second": "100001126",
        "other": "100001126",
        "active": 1,
        "abn": "1",
        "diocese": 5,
        "chargeFees": 0,
        "code": "m4u-sbps",
        "entityType": "1",
        "legalName": null
    },
    {
        "ID": 50510,
        "name": "Me4U-St Bernadettes School",
        "first": "100001126",
        "second": "100001126",
        "other": "100001126",
        "active": 1,
        "abn": "1",
        "diocese": 5,
        "chargeFees": 0,
        "code": "m4u-sbs",
        "entityType": "1",
        "legalName": null
    },
    {
        "ID": 50520,
        "name": "Me4U-St Brigid's Catholic School",
        "first": "100001126",
        "second": "100001126",
        "other": "100001126",
        "active": 1,
        "abn": "1",
        "diocese": 5,
        "chargeFees": 0,
        "code": "m4u-sbcs",
        "entityType": "1",
        "legalName": null
    },
    {
        "ID": 50530,
        "name": "Me4U-St Brigid's School",
        "first": "100001126",
        "second": "100001126",
        "other": "100001126",
        "active": 1,
        "abn": "1",
        "diocese": 5,
        "chargeFees": 0,
        "code": "m4u-sbrs",
        "entityType": "1",
        "legalName": null
    },
    {
        "ID": 50540,
        "name": "Me4U-St Catherine's School",
        "first": "100001126",
        "second": "100001126",
        "other": "100001126",
        "active": 1,
        "abn": "1",
        "diocese": 5,
        "chargeFees": 0,
        "code": "m4u-scs",
        "entityType": "1",
        "legalName": null
    },
    {
        "ID": 50550,
        "name": "Me4U-St Columba College",
        "first": "100001126",
        "second": "100001126",
        "other": "100001126",
        "active": 1,
        "abn": "1",
        "diocese": 5,
        "chargeFees": 0,
        "code": "m4u-scc",
        "entityType": "1",
        "legalName": null
    },
    {
        "ID": 50560,
        "name": "Me4U-St Columba Memorial School",
        "first": "100001126",
        "second": "100001126",
        "other": "100001126",
        "active": 1,
        "abn": "1",
        "diocese": 5,
        "chargeFees": 0,
        "code": "m4u-scms",
        "entityType": "1",
        "legalName": null
    },
    {
        "ID": 50570,
        "name": "Me4U-St Dominic's Priory College",
        "first": "100001126",
        "second": "100001126",
        "other": "100001126",
        "active": 1,
        "abn": "1",
        "diocese": 5,
        "chargeFees": 0,
        "code": "m4u-sdpc",
        "entityType": "1",
        "legalName": null
    },
    {
        "ID": 50580,
        "name": "Me4U-St Francis de Sales College",
        "first": "100001126",
        "second": "100001126",
        "other": "100001126",
        "active": 1,
        "abn": "1",
        "diocese": 5,
        "chargeFees": 0,
        "code": "m4u-sfdsc",
        "entityType": "1",
        "legalName": null
    },
    {
        "ID": 50590,
        "name": "Me4U-St Francis of Assisi School",
        "first": "100001126",
        "second": "100001126",
        "other": "100001126",
        "active": 1,
        "abn": "1",
        "diocese": 5,
        "chargeFees": 0,
        "code": "m4u-sfoas",
        "entityType": "1",
        "legalName": null
    },
    {
        "ID": 50600,
        "name": "Me4U-St Francis School Lockleys",
        "first": "100001126",
        "second": "100001126",
        "other": "100001126",
        "active": 1,
        "abn": "1",
        "diocese": 5,
        "chargeFees": 0,
        "code": "m4u-sfsl",
        "entityType": "1",
        "legalName": null
    },
    {
        "ID": 50610,
        "name": "Me4U-St Francis Xavier's Regional Catholic School",
        "first": "100001126",
        "second": "100001126",
        "other": "100001126",
        "active": 1,
        "abn": "1",
        "diocese": 5,
        "chargeFees": 0,
        "code": "m4u-sfxrcs",
        "entityType": "1",
        "legalName": null
    },
    {
        "ID": 50620,
        "name": "Me4U-St Gabriel's School Enfield",
        "first": "100001126",
        "second": "100001126",
        "other": "100001126",
        "active": 1,
        "abn": "1",
        "diocese": 5,
        "chargeFees": 0,
        "code": "m4u-sgse",
        "entityType": "1",
        "legalName": null
    },
    {
        "ID": 50630,
        "name": "Me4U-St Ignatius College",
        "first": "100001126",
        "second": "100001126",
        "other": "100001126",
        "active": 1,
        "abn": "1",
        "diocese": 5,
        "chargeFees": 0,
        "code": "m4u-sic",
        "entityType": "1",
        "legalName": null
    },
    {
        "ID": 50640,
        "name": "Me4U-St James School",
        "first": "100001126",
        "second": "100001126",
        "other": "100001126",
        "active": 1,
        "abn": "1",
        "diocese": 5,
        "chargeFees": 0,
        "code": "m4u-sjs",
        "entityType": "1",
        "legalName": null
    },
    {
        "ID": 50650,
        "name": "Me4U-St John Bosco School",
        "first": "100001126",
        "second": "100001126",
        "other": "100001126",
        "active": 1,
        "abn": "1",
        "diocese": 5,
        "chargeFees": 0,
        "code": "m4u-sjbs",
        "entityType": "1",
        "legalName": null
    },
    {
        "ID": 50660,
        "name": "Me4U-St John the Apostle Parish School",
        "first": "100001126",
        "second": "100001126",
        "other": "100001126",
        "active": 1,
        "abn": "1",
        "diocese": 5,
        "chargeFees": 0,
        "code": "m4u-sjtaps",
        "entityType": "1",
        "legalName": null
    },
    {
        "ID": 50670,
        "name": "Me4U-St John the Baptist Catholic School",
        "first": "100001126",
        "second": "100001126",
        "other": "100001126",
        "active": 1,
        "abn": "1",
        "diocese": 5,
        "chargeFees": 0,
        "code": "m4u-sjtbcs",
        "entityType": "1",
        "legalName": null
    },
    {
        "ID": 50680,
        "name": "Me4U-St Joseph's Memorial School",
        "first": "100001126",
        "second": "100001126",
        "other": "100001126",
        "active": 1,
        "abn": "1",
        "diocese": 5,
        "chargeFees": 0,
        "code": "m4u-sjms",
        "entityType": "1",
        "legalName": null
    },
    {
        "ID": 50690,
        "name": "Me4U-St Joseph's School Barmera",
        "first": "100001126",
        "second": "100001126",
        "other": "100001126",
        "active": 1,
        "abn": "1",
        "diocese": 5,
        "chargeFees": 0,
        "code": "m4u-sjsb",
        "entityType": "1",
        "legalName": null
    },
    {
        "ID": 50700,
        "name": "Me4U-St Joseph's School Clare",
        "first": "100001126",
        "second": "100001126",
        "other": "100001126",
        "active": 1,
        "abn": "1",
        "diocese": 5,
        "chargeFees": 0,
        "code": "m4u-sjsc",
        "entityType": "1",
        "legalName": null
    },
    {
        "ID": 50710,
        "name": "Me4U-St Joseph's School Gladstone",
        "first": "100001126",
        "second": "100001126",
        "other": "100001126",
        "active": 1,
        "abn": "1",
        "diocese": 5,
        "chargeFees": 0,
        "code": "m4u-sjsg",
        "entityType": "1",
        "legalName": null
    },
    {
        "ID": 50720,
        "name": "Me4U-St Joseph's School Hectorville",
        "first": "100001126",
        "second": "100001126",
        "other": "100001126",
        "active": 1,
        "abn": "1",
        "diocese": 5,
        "chargeFees": 0,
        "code": "m4u-sjsh",
        "entityType": "1",
        "legalName": null
    },
    {
        "ID": 50730,
        "name": "Me4U-St Joseph's School Kingswood",
        "first": "100001126",
        "second": "100001126",
        "other": "100001126",
        "active": 1,
        "abn": "1",
        "diocese": 5,
        "chargeFees": 0,
        "code": "m4u-sjsk",
        "entityType": "1",
        "legalName": null
    },
    {
        "ID": 50740,
        "name": "Me4U-St Joseph's School Murray Bridge",
        "first": "100001126",
        "second": "100001126",
        "other": "100001126",
        "active": 1,
        "abn": "1",
        "diocese": 5,
        "chargeFees": 0,
        "code": "m4u-sjsmb",
        "entityType": "1",
        "legalName": null
    },
    {
        "ID": 50750,
        "name": "Me4U-St Joseph's School Ottoway",
        "first": "100001126",
        "second": "100001126",
        "other": "100001126",
        "active": 1,
        "abn": "1",
        "diocese": 5,
        "chargeFees": 0,
        "code": "m4u-sjso",
        "entityType": "1",
        "legalName": null
    },
    {
        "ID": 50760,
        "name": "Me4U-St Joseph's School Payneham",
        "first": "100001126",
        "second": "100001126",
        "other": "100001126",
        "active": 1,
        "abn": "1",
        "diocese": 5,
        "chargeFees": 0,
        "code": "m4u-sjsp",
        "entityType": "1",
        "legalName": null
    },
    {
        "ID": 50770,
        "name": "Me4U-St Joseph's Peterborough",
        "first": "100001126",
        "second": "100001126",
        "other": "100001126",
        "active": 1,
        "abn": "1",
        "diocese": 5,
        "chargeFees": 0,
        "code": "m4u-sjp",
        "entityType": "1",
        "legalName": null
    },
    {
        "ID": 50780,
        "name": "Me4U-St Joseph's School Port Lincoln",
        "first": "100001126",
        "second": "100001126",
        "other": "100001126",
        "active": 1,
        "abn": "1",
        "diocese": 5,
        "chargeFees": 0,
        "code": "m4u-sjspl",
        "entityType": "1",
        "legalName": null
    },
    {
        "ID": 50790,
        "name": "Me4U-St Joseph's School Renmark",
        "first": "100001126",
        "second": "100001126",
        "other": "100001126",
        "active": 1,
        "abn": "1",
        "diocese": 5,
        "chargeFees": 0,
        "code": "m4u-sjsr",
        "entityType": "1",
        "legalName": null
    },
    {
        "ID": 50800,
        "name": "Me4U-St Joseph's School Tranmere",
        "first": "100001126",
        "second": "100001126",
        "other": "100001126",
        "active": 1,
        "abn": "1",
        "diocese": 5,
        "chargeFees": 0,
        "code": "m4u-sjst",
        "entityType": "1",
        "legalName": null
    },
    {
        "ID": 50810,
        "name": "Me4U-St Joseph's School West Hindmarsh",
        "first": "100001126",
        "second": "100001126",
        "other": "100001126",
        "active": 1,
        "abn": "1",
        "diocese": 5,
        "chargeFees": 0,
        "code": "m4u-sjswh",
        "entityType": "1",
        "legalName": null
    },
    {
        "ID": 50820,
        "name": "Me4U-St Margaret Mary's School",
        "first": "100001126",
        "second": "100001126",
        "other": "100001126",
        "active": 1,
        "abn": "1",
        "diocese": 5,
        "chargeFees": 0,
        "code": "m4u-smmas",
        "entityType": "1",
        "legalName": null
    },
    {
        "ID": 50830,
        "name": "Me4U-St Mark's College",
        "first": "100001126",
        "second": "100001126",
        "other": "100001126",
        "active": 1,
        "abn": "1",
        "diocese": 5,
        "chargeFees": 0,
        "code": "m4u-smc",
        "entityType": "1",
        "legalName": null
    },
    {
        "ID": 50840,
        "name": "Me4U-St Martin de Porres School",
        "first": "100001126",
        "second": "100001126",
        "other": "100001126",
        "active": 1,
        "abn": "1",
        "diocese": 5,
        "chargeFees": 0,
        "code": "m4u-smdps",
        "entityType": "1",
        "legalName": null
    },
    {
        "ID": 50850,
        "name": "Me4U-St Martin's Catholic Primary School",
        "first": "100001126",
        "second": "100001126",
        "other": "100001126",
        "active": 1,
        "abn": "1",
        "diocese": 5,
        "chargeFees": 0,
        "code": "m4u-smcps",
        "entityType": "1",
        "legalName": null
    },
    {
        "ID": 50860,
        "name": "Me4U-St Mary MacKillop ",
        "first": "100001126",
        "second": "100001126",
        "other": "100001126",
        "active": 1,
        "abn": "1",
        "diocese": 5,
        "chargeFees": 0,
        "code": "m4u-smm",
        "entityType": "1",
        "legalName": null
    },
    {
        "ID": 50870,
        "name": "Me4U-St Mary Magdalene's School",
        "first": "100001126",
        "second": "100001126",
        "other": "100001126",
        "active": 1,
        "abn": "1",
        "diocese": 5,
        "chargeFees": 0,
        "code": "m4u-smams",
        "entityType": "1",
        "legalName": null
    },
    {
        "ID": 50880,
        "name": "Me4U-St Mary's College",
        "first": "100001126",
        "second": "100001126",
        "other": "100001126",
        "active": 1,
        "abn": "1",
        "diocese": 5,
        "chargeFees": 0,
        "code": "m4u-smac",
        "entityType": "1",
        "legalName": null
    },
    {
        "ID": 50890,
        "name": "Me4U-St Mary's Memorial School",
        "first": "100001126",
        "second": "100001126",
        "other": "100001126",
        "active": 1,
        "abn": "1",
        "diocese": 5,
        "chargeFees": 0,
        "code": "m4u-smms",
        "entityType": "1",
        "legalName": null
    },
    {
        "ID": 50900,
        "name": "Me4U-St Michael's College",
        "first": "100001126",
        "second": "100001126",
        "other": "100001126",
        "active": 1,
        "abn": "1",
        "diocese": 5,
        "chargeFees": 0,
        "code": "m4u-smic",
        "entityType": "1",
        "legalName": null
    },
    {
        "ID": 50910,
        "name": "Me4U-St Monica's Parish School",
        "first": "100001126",
        "second": "100001126",
        "other": "100001126",
        "active": 1,
        "abn": "1",
        "diocese": 5,
        "chargeFees": 0,
        "code": "m4u-smps",
        "entityType": "1",
        "legalName": null
    },
    {
        "ID": 50920,
        "name": "Me4U-St Patrick's School",
        "first": "100001126",
        "second": "100001126",
        "other": "100001126",
        "active": 1,
        "abn": "1",
        "diocese": 5,
        "chargeFees": 0,
        "code": "m4u-sps",
        "entityType": "1",
        "legalName": null
    },
    {
        "ID": 50930,
        "name": "Me4U-St Patrick's Special School",
        "first": "100001126",
        "second": "100001126",
        "other": "100001126",
        "active": 1,
        "abn": "1",
        "diocese": 5,
        "chargeFees": 0,
        "code": "m4u-spss",
        "entityType": "1",
        "legalName": null
    },
    {
        "ID": 50940,
        "name": "Me4U-St Patrick's Technical College",
        "first": "100001126",
        "second": "100001126",
        "other": "100001126",
        "active": 1,
        "abn": "1",
        "diocese": 5,
        "chargeFees": 0,
        "code": "m4u-sptc",
        "entityType": "1",
        "legalName": null
    },
    {
        "ID": 50950,
        "name": "Me4U-St Paul's College",
        "first": "100001126",
        "second": "100001126",
        "other": "100001126",
        "active": 1,
        "abn": "1",
        "diocese": 5,
        "chargeFees": 0,
        "code": "m4u-spc",
        "entityType": "1",
        "legalName": null
    },
    {
        "ID": 50960,
        "name": "Me4U-St Pius X School",
        "first": "100001126",
        "second": "100001126",
        "other": "100001126",
        "active": 1,
        "abn": "1",
        "diocese": 5,
        "chargeFees": 0,
        "code": "m4u-spxs",
        "entityType": "1",
        "legalName": null
    },
    {
        "ID": 50970,
        "name": "Me4U-St Raphael's School",
        "first": "100001126",
        "second": "100001126",
        "other": "100001126",
        "active": 1,
        "abn": "1",
        "diocese": 5,
        "chargeFees": 0,
        "code": "m4u-srs",
        "entityType": "1",
        "legalName": null
    },
    {
        "ID": 50980,
        "name": "Me4U-St Teresa's School",
        "first": "100001126",
        "second": "100001126",
        "other": "100001126",
        "active": 1,
        "abn": "1",
        "diocese": 5,
        "chargeFees": 0,
        "code": "m4u-sts",
        "entityType": "1",
        "legalName": null
    },
    {
        "ID": 50990,
        "name": "Me4U-St Therese Primary School - Colonel Light Gardens",
        "first": "100001126",
        "second": "100001126",
        "other": "100001126",
        "active": 1,
        "abn": "1",
        "diocese": 5,
        "chargeFees": 0,
        "code": "m4u-stps-clg",
        "entityType": "1",
        "legalName": null
    },
    {
        "ID": 51000,
        "name": "Me4U-St Thomas More School",
        "first": "100001126",
        "second": "100001126",
        "other": "100001126",
        "active": 1,
        "abn": "1",
        "diocese": 5,
        "chargeFees": 0,
        "code": "m4u-stms",
        "entityType": "1",
        "legalName": null
    },
    {
        "ID": 51010,
        "name": "Me4U-St Thomas School and Pre-School Goodwood",
        "first": "100001126",
        "second": "100001126",
        "other": "100001126",
        "active": 1,
        "abn": "1",
        "diocese": 5,
        "chargeFees": 0,
        "code": "m4u-stsapg",
        "entityType": "1",
        "legalName": null
    },
    {
        "ID": 51020,
        "name": "Me4U-Star of the Sea School",
        "first": "100001126",
        "second": "100001126",
        "other": "100001126",
        "active": 1,
        "abn": "1",
        "diocese": 5,
        "chargeFees": 0,
        "code": "m4u-sotss",
        "entityType": "1",
        "legalName": null
    },
    {
        "ID": 51030,
        "name": "Me4U-Stella Maris Parish School",
        "first": "100001126",
        "second": "100001126",
        "other": "100001126",
        "active": 1,
        "abn": "1",
        "diocese": 5,
        "chargeFees": 0,
        "code": "m4u-smpas",
        "entityType": "1",
        "legalName": null
    },
    {
        "ID": 51040,
        "name": "Me4U-Tenison Woods Catholic Primary School Richmond",
        "first": "100001126",
        "second": "100001126",
        "other": "100001126",
        "active": 1,
        "abn": "1",
        "diocese": 5,
        "chargeFees": 0,
        "code": "m4u-twcpsr",
        "entityType": "1",
        "legalName": null
    },
    {
        "ID": 51050,
        "name": "Me4U-Tenison Woods College",
        "first": "100001126",
        "second": "100001126",
        "other": "100001126",
        "active": 1,
        "abn": "1",
        "diocese": 5,
        "chargeFees": 0,
        "code": "m4u-twc",
        "entityType": "1",
        "legalName": null
    },
    {
        "ID": 51060,
        "name": "Me4U-Thomas More College",
        "first": "100001126",
        "second": "100001126",
        "other": "100001126",
        "active": 1,
        "abn": "1",
        "diocese": 5,
        "chargeFees": 0,
        "code": "m4u-tmc",
        "entityType": "1",
        "legalName": null
    },
    {
        "ID": 51070,
        "name": "Me4U-Whitefriars School",
        "first": "100001126",
        "second": "100001126",
        "other": "100001126",
        "active": 1,
        "abn": "1",
        "diocese": 5,
        "chargeFees": 0,
        "code": "m4u-ws",
        "entityType": "1",
        "legalName": null
    },
    {
        "ID": 51080,
        "name": "Me4U-Xavier College",
        "first": "100001126",
        "second": "100001126",
        "other": "100001126",
        "active": 1,
        "abn": "1",
        "diocese": 5,
        "chargeFees": 0,
        "code": "m4u-xc",
        "entityType": "1",
        "legalName": null
    },
    {
        "ID": 30130,
        "name": "Holy Trinity Blackbutt North",
        "first": "5026",
        "second": "5025",
        "other": "5025",
        "active": 1,
        "abn": "1",
        "diocese": 3,
        "chargeFees": 0,
        "code": "holytrinity",
        "entityType": "0",
        "legalName": "",
        "feedName": "blackbuttnorth"
    },
    {
        "ID": 30010,
        "name": "All Saints Blackbutt South",
        "first": "61",
        "second": "60",
        "other": "60",
        "active": 1,
        "abn": "1",
        "diocese": 3,
        "chargeFees": 0,
        "code": "allsaints",
        "entityType": "0",
        "legalName": "",
        "feedName": "blackbuttsouth"
    },
    {
        "ID": 30030,
        "name": "Boolaroo-Warners Bay",
        "first": "5264",
        "second": "5263",
        "other": "5263",
        "active": 1,
        "abn": "1",
        "diocese": 3,
        "chargeFees": 0,
        "code": "bw",
        "entityType": "0",
        "legalName": "",
        "feedName": "boolaroowarnersbay"
    },
    {
        "ID": 30040,
        "name": "Booragul",
        "first": "5264",
        "second": "48",
        "other": "48",
        "active": 1,
        "abn": "1",
        "diocese": 3,
        "chargeFees": 0,
        "code": "booragul",
        "entityType": "0",
        "legalName": "",
        "feedName": "boolaroowarnersbay"
    },
    {
        "ID": 30060,
        "name": "Cessnock",
        "first": "5117",
        "second": "5116",
        "other": "5116",
        "active": 1,
        "abn": "1",
        "diocese": 3,
        "chargeFees": 0,
        "code": "cessnock",
        "entityType": "0",
        "legalName": "",
        "feedName": "cessnock"
    },
    {
        "ID": 30160,
        "name": "Kurri Kurri",
        "first": "84",
        "second": "83",
        "other": "83",
        "active": 1,
        "abn": "1",
        "diocese": 3,
        "chargeFees": 0,
        "code": "kk",
        "entityType": "0",
        "legalName": "",
        "feedName": "cessnock"
    },
    {
        "ID": 30070,
        "name": "Denman",
        "first": "5075",
        "second": "5074",
        "other": "5074",
        "active": 1,
        "abn": "1",
        "diocese": 3,
        "chargeFees": 0,
        "code": "denman",
        "entityType": "0",
        "legalName": "",
        "feedName": "denman"
    },
    {
        "ID": 30080,
        "name": "Dungog",
        "first": "8",
        "second": "5055",
        "other": "5055",
        "active": 1,
        "abn": "1",
        "diocese": 3,
        "chargeFees": 0,
        "code": "dungog",
        "entityType": "0",
        "legalName": "",
        "feedName": "dungog"
    },
    {
        "ID": 30140,
        "name": "Jesus the Good Shepherd East Lake Macquarie",
        "first": "5072",
        "second": "5071",
        "other": "5071",
        "active": 1,
        "abn": "1",
        "diocese": 3,
        "chargeFees": 0,
        "code": "elm",
        "entityType": "0",
        "legalName": "",
        "feedName": "eastlakemacquarie"
    },
    {
        "ID": 30100,
        "name": "Forster Tuncurry",
        "first": "5063",
        "second": "5057",
        "other": "5057",
        "active": 1,
        "abn": "1",
        "diocese": 3,
        "chargeFees": 0,
        "code": "forstertuncurry",
        "entityType": "0",
        "legalName": "",
        "feedName": "forstertuncurry"
    },
    {
        "ID": 30110,
        "name": "Gloucester",
        "first": "5028",
        "second": "10",
        "other": "10",
        "active": 1,
        "abn": "1",
        "diocese": 3,
        "chargeFees": 0,
        "code": "gloucester",
        "entityType": "0",
        "legalName": "",
        "feedName": "gloucester"
    },
    {
        "ID": 30120,
        "name": "Gresford",
        "first": "7",
        "second": "1085",
        "other": "1085",
        "active": 1,
        "abn": "1",
        "diocese": 3,
        "chargeFees": 0,
        "code": "gresford",
        "entityType": "0",
        "legalName": "",
        "feedName": "gresford"
    },
    {
        "ID": 30200,
        "name": "Mayfield",
        "first": "5092",
        "second": "5141",
        "other": "5141",
        "active": 1,
        "abn": "1",
        "diocese": 3,
        "chargeFees": 0,
        "code": "mayfield",
        "entityType": "0",
        "legalName": "",
        "feedName": "innernewcastle"
    },
    {
        "ID": 30320,
        "name": "St Benedict's Inner Newcastle",
        "first": "5152",
        "second": "5153",
        "other": "5153",
        "active": 1,
        "abn": "1",
        "diocese": 3,
        "chargeFees": 0,
        "code": "newcastle",
        "entityType": "0",
        "legalName": "",
        "feedName": "innernewcastle"
    },
    {
        "ID": 30330,
        "name": "Stockton",
        "first": "22",
        "second": "21",
        "other": "21",
        "active": 1,
        "abn": "1",
        "diocese": 3,
        "chargeFees": 0,
        "code": "stockton",
        "entityType": "0",
        "legalName": "",
        "feedName": "innernewcastle"
    },
    {
        "ID": 30150,
        "name": "Krambach",
        "first": "5518",
        "second": "5010",
        "other": "5010",
        "active": 1,
        "abn": "1",
        "diocese": 3,
        "chargeFees": 0,
        "code": "krambach",
        "entityType": "0",
        "legalName": "",
        "feedName": "krambach"
    },
    {
        "ID": 30180,
        "name": "MacKillop",
        "first": "1198",
        "second": "1197",
        "other": "1197",
        "active": 1,
        "abn": "1",
        "diocese": 3,
        "chargeFees": 0,
        "code": "mackillop",
        "entityType": "0",
        "legalName": "",
        "feedName": "mackillop"
    },
    {
        "ID": 30020,
        "name": "Beresfield",
        "first": "5445",
        "second": "1186",
        "other": "1186",
        "active": 1,
        "abn": "1",
        "diocese": 3,
        "chargeFees": 0,
        "code": "beresfield",
        "entityType": "0",
        "legalName": "",
        "feedName": "maitland"
    },
    {
        "ID": 30090,
        "name": "East Maitland",
        "first": "5443",
        "second": "56",
        "other": "56",
        "active": 1,
        "abn": "1",
        "diocese": 3,
        "chargeFees": 0,
        "code": "eastmaitland",
        "entityType": "0",
        "legalName": "",
        "feedName": "maitland"
    },
    {
        "ID": 30170,
        "name": "Lochinvar",
        "first": "5448",
        "second": "80",
        "other": "80",
        "active": 1,
        "abn": "1",
        "diocese": 3,
        "chargeFees": 0,
        "code": "lochinvar",
        "entityType": "0",
        "legalName": "",
        "feedName": "maitland"
    },
    {
        "ID": 30190,
        "name": "Maitland",
        "first": "5444",
        "second": "40",
        "other": "40",
        "active": 1,
        "abn": "1",
        "diocese": 3,
        "chargeFees": 0,
        "code": "maitland",
        "entityType": "0",
        "legalName": "",
        "feedName": "maitland"
    },
    {
        "ID": 30230,
        "name": "Morpeth",
        "first": "5447",
        "second": "54",
        "other": "54",
        "active": 1,
        "abn": "1",
        "diocese": 3,
        "chargeFees": 0,
        "code": "morpeth",
        "entityType": "0",
        "legalName": "",
        "feedName": "maitland"
    },
    {
        "ID": 30290,
        "name": "Rutherford",
        "first": "5446",
        "second": "5048",
        "other": "5048",
        "active": 1,
        "abn": "1",
        "diocese": 3,
        "chargeFees": 0,
        "code": "rutherford",
        "entityType": "0",
        "legalName": "",
        "feedName": "maitland"
    },
    {
        "ID": 30210,
        "name": "Merriwa",
        "first": "16",
        "second": "14",
        "other": "14",
        "active": 1,
        "abn": "1",
        "diocese": 3,
        "chargeFees": 0,
        "code": "merriwa",
        "entityType": "0",
        "legalName": "",
        "feedName": "merriwa"
    },
    {
        "ID": 30220,
        "name": "Morisset",
        "first": "5016",
        "second": "5004",
        "other": "5004",
        "active": 1,
        "abn": "1",
        "diocese": 3,
        "chargeFees": 0,
        "code": "morisset",
        "entityType": "0",
        "legalName": "",
        "feedName": "morisset"
    },
    {
        "ID": 30250,
        "name": "Muswellbrook",
        "first": "74",
        "second": "73",
        "other": "73",
        "active": 1,
        "abn": "1",
        "diocese": 3,
        "chargeFees": 0,
        "code": "muswellbrook",
        "entityType": "0",
        "legalName": "",
        "feedName": "muswellbrook"
    },
    {
        "ID": 30260,
        "name": "Myall Coast",
        "first": "5134",
        "second": "5133",
        "other": "5133",
        "active": 1,
        "abn": "1",
        "diocese": 3,
        "chargeFees": 0,
        "code": "myallcoast",
        "entityType": "0",
        "legalName": "",
        "feedName": "myallcoast"
    },
    {
        "ID": 30270,
        "name": "Nelson Bay",
        "first": "5159",
        "second": "5157",
        "other": "5157",
        "active": 1,
        "abn": "1",
        "diocese": 3,
        "chargeFees": 0,
        "code": "nelsonbay",
        "entityType": "0",
        "legalName": "",
        "feedName": "nelsonbay"
    },
    {
        "ID": 30280,
        "name": "Raymond Terrace",
        "first": "5138",
        "second": "5137",
        "other": "5137",
        "active": 1,
        "abn": "1",
        "diocese": 3,
        "chargeFees": 0,
        "code": "raymond",
        "entityType": "0",
        "legalName": "",
        "feedName": "raymondterrace"
    },
    {
        "ID": 30240,
        "name": "Murrurundi",
        "first": "5127",
        "second": "5128",
        "other": "5128",
        "active": 1,
        "abn": "1",
        "diocese": 3,
        "chargeFees": 0,
        "code": "murrurundi",
        "entityType": "0",
        "legalName": "",
        "feedName": "scone"
    },
    {
        "ID": 30300,
        "name": "Scone",
        "first": "5052",
        "second": "5032",
        "other": "5032",
        "active": 1,
        "abn": "1",
        "diocese": 3,
        "chargeFees": 0,
        "code": "scone",
        "entityType": "0",
        "legalName": "",
        "feedName": "scone"
    },
    {
        "ID": 30050,
        "name": "Branxton",
        "first": "78",
        "second": "5370",
        "other": "5370",
        "active": 1,
        "abn": "1",
        "diocese": 3,
        "chargeFees": 0,
        "code": "branxton",
        "entityType": "0",
        "legalName": "",
        "feedName": "singleton"
    },
    {
        "ID": 30310,
        "name": "Singleton",
        "first": "11",
        "second": "9",
        "other": "9",
        "active": 1,
        "abn": "1",
        "diocese": 3,
        "chargeFees": 0,
        "code": "singleton",
        "entityType": "0",
        "legalName": "",
        "feedName": "singleton"
    },
    {
        "ID": 30340,
        "name": "Sugarloaf",
        "first": "18",
        "second": "5180",
        "other": "5180",
        "active": 1,
        "abn": "1",
        "diocese": 3,
        "chargeFees": 0,
        "code": "sugarloaf",
        "entityType": "0",
        "legalName": "",
        "feedName": "sugarloaf"
    },
    {
        "ID": 30350,
        "name": "Taree",
        "first": "5058",
        "second": "5064",
        "other": "5064",
        "active": 1,
        "abn": "1",
        "diocese": 3,
        "chargeFees": 0,
        "code": "taree",
        "entityType": "0",
        "legalName": "",
        "feedName": "taree"
    },
    {
        "ID": 30380,
        "name": "Wingham",
        "first": "5030",
        "second": "5029",
        "other": "5029",
        "active": 1,
        "abn": "1",
        "diocese": 3,
        "chargeFees": 0,
        "code": "wingham",
        "entityType": "0",
        "legalName": "",
        "feedName": "taree"
    },
    {
        "ID": 30360,
        "name": "Toronto",
        "first": "35",
        "second": "36",
        "other": "36",
        "active": 1,
        "abn": "1",
        "diocese": 3,
        "chargeFees": 0,
        "code": "toronto",
        "entityType": "0",
        "legalName": "",
        "feedName": "toronto"
    },
    {
        "ID": 30370,
        "name": "Wallsend-Shortland",
        "first": "28",
        "second": "27",
        "other": "27",
        "active": 1,
        "abn": "1",
        "diocese": 3,
        "chargeFees": 0,
        "code": "ws",
        "entityType": "0",
        "legalName": "",
        "feedName": "wallsendshortland"
    }
];
//# sourceMappingURL=ParishLookup.js.map